import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { productsAPI } from '../../lib/api';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const response = await productsAPI.getAll();
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const columns = [
    { key: 'sku', label: 'SKU' },
    { key: 'name', label: 'Name' },
    { key: 'category', label: 'Category' },
    { key: 'price', label: 'Price', type: 'currency' },
    { key: 'cost', label: 'Cost', type: 'currency' },
    { key: 'quantity', label: 'Stock' },
  ];

  const formFields = [
    { name: 'name', label: 'Product Name', required: true, placeholder: 'Enter product name' },
    { name: 'sku', label: 'SKU', placeholder: 'PRD-001' },
    { name: 'category', label: 'Category', placeholder: 'e.g., Electronics, Furniture' },
    { name: 'price', label: 'Selling Price', type: 'number', defaultValue: 0 },
    { name: 'cost', label: 'Cost Price', type: 'number', defaultValue: 0 },
    { name: 'quantity', label: 'Initial Stock', type: 'number', defaultValue: 0 },
    { name: 'min_stock', label: 'Minimum Stock Level', type: 'number', defaultValue: 0 },
    { name: 'unit', label: 'Unit', placeholder: 'pcs, kg, liter', defaultValue: 'pcs' },
  ];

  const handleAdd = async (data) => {
    await productsAPI.create(data);
    fetchProducts();
  };

  const handleEdit = async (id, data) => {
    await productsAPI.update(id, data);
    fetchProducts();
  };

  const handleDelete = async (id) => {
    await productsAPI.delete(id);
    fetchProducts();
  };

  return (
    <DataTable
      title="Products"
      description="Manage your product catalog"
      data={products}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
    />
  );
};

export default Products;
